// extracted by mini-css-extract-plugin
export default {"questionExplanation":"B_bW"};